import { SortOrder } from '@wix/ambassador-devcenter-v1-review/types';
import type { RatingHistogram } from '@wix/ambassador-appreviewssummaries-v1-app-reviews-summary/types';
import type { Essentials } from '../../../../../models';
import { normalizeReview } from './normalize-review';
import type { Review } from '../types';
import {
  getAllReviews,
  getUserReview,
  getAppReviewsSummary,
  getIsEligibleForReview,
} from './reviews-api.utils';

export type getReviewsSectionResponse = {
  reviews: Review[];
  userReview?: Review;
  isEligibleForReview: boolean;
  reviewsSummary: {
    totalReviews: number;
    averageRating: number;
    ratingHistogram: RatingHistogram;
  };
};

export async function getReviewsSectionData({
  httpClient,
  rpcClient,
  appId,
  sortMethod = 'publishedAt',
  limit = 5,
  offset = 0,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient?: Essentials['rpcClient'];
  limit?: number;
  appId: string;
  sortMethod?: string;
  offset?: number;
}): Promise<getReviewsSectionResponse> {
  const queryReviewsReq = {
    query: {
      filter: {
        appId,
        publishedAt: {
          $exists: true,
        },
      },
      sort: [{ fieldName: sortMethod, order: SortOrder.DESC }],
      paging: {
        limit,
        offset,
      },
    },
  };
  const queryAppReviewsSummaryReq = {
    query: {
      filter: {
        appId,
      },
    },
  };

  const [reviews, userReview, appReviewsSummary, isEligibleForReview] =
    await Promise.all([
      getAllReviews({ httpClient, rpcClient, queryReviewsReq }),
      getUserReview({ httpClient, rpcClient, appId }),
      getAppReviewsSummary({
        httpClient,
        rpcClient,
        queryAppReviewsSummaryReq,
      }),
      getIsEligibleForReview({ httpClient, appId }),
    ]);

  return {
    reviews:
      reviews?.map((review) => {
        return normalizeReview(review);
      }) ?? [],
    userReview: userReview ? normalizeReview(userReview) : undefined,
    isEligibleForReview: isEligibleForReview ?? false,
    reviewsSummary: {
      totalReviews: appReviewsSummary.totalReviews ?? 0,
      averageRating: appReviewsSummary.averageRating ?? 0,
      ratingHistogram: appReviewsSummary.ratingHistogram ?? {},
    },
  };
}
